module.exports = __webpack_public_path__ + "static/img/clean.2ef7abd6.png";